import { departmentAndEmployeeConstants } from "../constant/totalRecord.constants";

export const initialState = {
    listDepartmentSelectBox: {
        departmentId: "",
        departmentName: "",
    },
    listEmployeeSelectBox: {
        employeeId: "",
        employeeCode: "",
        employeeName: "",
    },
    listApproverSelectBox: {
        employeeId: "",
        employeeCode: "",
        employeeName: "",
    },
    listEmployeeWorkingSelectBox: {
        employeeId: "",
        employeeCode: "",
        employeeName: "",
    },
    isLoading: false,
    getting: false,
    errorCode: "",
    successCode: "",
};

const departmentAndEmployeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case departmentAndEmployeeConstants.GETTING:
            return {
                ...state,
                getting: true,
            };
        case departmentAndEmployeeConstants.GET_SUCCESS:
            return {
                ...state,
                listDepartmentSelectBox: action.departmentListAndEmployee.listDepartmentSelectBox,
                listEmployeeSelectBox: action.departmentListAndEmployee.listEmployeeSelectBox,
                listApproverSelectBox: action.departmentListAndEmployee.listApproverSelectBox,
                listEmployeeWorkingSelectBox: action.departmentListAndEmployee.listEmployeeWorkingSelectBox,
                isLoading: true,
                getting: false
            };
        case departmentAndEmployeeConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false,
                getting: false
            };
        default:
            return state;
    }
};

export default departmentAndEmployeeReducer;
